import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
});

/**
 * Alertas de los sensores del usuario autenticado.
 * params: { page, limit, days, status }
 */
export const getMyAlerts = async (params = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/alerts`, { params, headers: authHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error al obtener las alertas: ', error);
        throw error;
    }
};

/**
 * Todas las alertas con sus notificaciones (solo administrador).
 * params: { page, limit, days, status, sensorId }
 */
export const getAllAlerts = async (params = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/alerts/all`, { params, headers: authHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error al obtener todas las alertas: ', error);
        throw error;
    }
};
